import { useState, useEffect } from "react";
// material
import { Card, Container, TablePagination } from "@mui/material";
// components
import Scrollbar from "../table/Scrollbar";
import TableView from "../Table";
import {
  getHistoryPaymentHosts,
  getPaymentHostFilterConditions,
} from "../../services/payment";

import CircularLoader from "../circularLoader";
import FormSearch from "../FormSearch";
import CommonDialog from "../CustomDialog";
import PendingPaymentHostDetails from "./Dialogs/PendingPaymentHostDetails";
import Label from "../Label";

// ----------------------------------------------------------------------

export default function HistoryGroup() {
  const [historyGroup, setHistoryGroup] = useState({ results: [], count: 0 });
  const [loaded, setLoaded] = useState(false);
  const [tableData, setTableData] = useState();
  const [filterName, setFilterName] = useState();
  const [fParams, setFParams] = useState({});
  const [activeFilters, setActiveFilters] = useState({});
  const [itemId, setItemId] = useState(null);
  const [pagination, setPagination] = useState({
    page: 1,
    page_size: 50,
  });

  const queryPage = (queryParams) => {
    setLoaded(false);
    getHistoryPaymentHosts({
      setResponse: setHistoryGroup,
      filter: queryParams,
      setLoaded: setLoaded,
    });
    setPagination({
      page: queryParams.page || 1,
      page_size: queryParams.page_size || 50,
    });
  };

  const handleChangePage = (event, newPage) => {
    queryPage({
      ...activeFilters,
      page: newPage + 1,
      page_size: pagination.page_size,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    queryPage({
      ...activeFilters,
      page: 1,
      page_size: parseInt(event.target.value, 10),
    });
  };

  // ------------------ filterStuffies --------------------//
  const [fLoaded, setFLoaded] = useState(false);
  const [inputValues, setInputValues] = useState({});

  const onFilterSubmit = (params) => {
    const newParams = {
      ...params,
      name: params.name?.label,
      payment_brand: params.payment_brand?.id,
      name_input: inputValues?.name?.trim() || null,
      payment_brand_input: inputValues?.payment_brand?.trim() || null
    }
    setActiveFilters(newParams);
    queryPage({
      ...newParams,
      page: 1,
      page_size: pagination.page_size,
    });
  };

  useEffect(() => {
    getPaymentHostFilterConditions(setFParams, setFLoaded);
    queryPage(pagination);
  }, []);

  const formatData = (input) => {
    let tableData = [];
    if (!input || !input.results) return tableData;
    input.results.forEach(({ id, name, payment_brand, action, is_approved }) => {
      tableData.push({
        id: id,
        payment_host: name && name,
        payment_brand: payment_brand && payment_brand.name,
        action: action && action,
        approved: (
          <>
            <Label variant="ghost" color={is_approved ? "success" : "error"}>
              {is_approved ? "YES" : "NO"}
            </Label>
          </>
        ),
      });
    });
    return tableData;
  };

  useEffect(() => {
    if (historyGroup) {
      setTableData(formatData(historyGroup));
    }
  }, [historyGroup]);

  const schema = [
    {
      type: "search-select",
      label: "Payment Host",
      param: "name",
      options: fParams?.name?.map((host) => ({
        label: host.name,
        id: host.id,
      })),
      inputValues,
      setInputValues,
    },
    {
      type: "search-select",
      label: "Payment Brand",
      param: "payment_brand",
      options: fParams?.payment_brand?.map((brand) => ({
        label: brand.name,
        id: brand.id,
      })),
      inputValues,
      setInputValues,
    },
    {
      type: "select",
      label: "Action",
      param: "action",
      id: false,
      options: ["Add", "Remove", "Update"]
    }
  ]

  return (
    <Container>
      <FormSearch
        schema={schema}
        loading={!fLoaded}
        onSearch={onFilterSubmit}
      />
      {loaded ? (
        <Card>
          <Scrollbar>
            <TableView
              rows={tableData || []}
              link={`/3/app/details/payment-host-history~id~`}
              onSelectItem={(id) => setItemId(id)}
              count={historyGroup?.count || 0}
              query={filterName}
            />
          </Scrollbar>
          <TablePagination
            rowsPerPageOptions={[25, 50, 100]}
            component="div"
            count={historyGroup?.count || 0}
            rowsPerPage={pagination.page_size}
            page={pagination.page - 1}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      ) : (
        <CircularLoader />
      )}

      {itemId && (
        <CommonDialog
          title={"Payment Host History Details"}
          onClose={() => setItemId(null)}
        >
          <PendingPaymentHostDetails itemId={itemId} isViewHistory />
        </CommonDialog>
      )}
    </Container>
  );
}
